export const BASE_CLASS = 'mt-PanelEquipment'

export const GROUP_KEY_BASIC_DATA_SHEET = 'basicDataSheet'
const GROUP_KEY_STANDARD = 'standard'
const GROUP_KEY_OPTIONAL = 'optional'

export const SECTION_LABEL_MAP = {
  [GROUP_KEY_BASIC_DATA_SHEET]: 'COMMON.BASIC_DATA_SHEET',
  [GROUP_KEY_STANDARD]: 'COMMON.EQUIPMENT.STANDARD',
  [GROUP_KEY_OPTIONAL]: 'COMMON.EQUIPMENT.OPTIONAL'
}

export const BASE_TEST_ID = 'tab-content'

export const CTA_TYPES = {
  button: 'button',
  link: 'link'
}

export const DISPLAY_TYPES = {
  accordion: 'accordion',
  tabs: 'tabs'
}
